export const SWITCHING_CONTROLUI_INTERVAL = 3000;
export const READING_GUIDE_DIRECTION_TTB = 'TTB';
export const READING_GUIDE_DIRECTION_LTR = 'LTR';
export const READING_GUIDE_DIRECTION_RTL = 'RTL';

export const TOOLTIP_DURATION = 2400;

export const INDEX_SLIDER_TYPE_RATIO = 'ratio';
export const INDEX_SLIDER_TYPE_ABSOLUTE = 'absolute';